import r from"../formatMuiErrorMessage.js";function t(t){if("string"!=typeof t)throw new Error("production"!==process.env.NODE_ENV?"MUI: `capitalize(string)` expects a string argument.":r(7));return t.charAt(0).toUpperCase()+t.slice(1)}export{t as default};
//# sourceMappingURL=capitalize.js.map
